const config = {
  requestRetries: 3,
  requestTimeout: 20000,
  videoParams: {
    // mediasoup params
    encodings: [
      {
        rid: "r0",
        maxBitrate: 100_000,
        scaleResolutionDownBy: 4.0,
        scalabilityMode: "S1T3",
      },
      {
        rid: "r1",
        maxBitrate: 300_000,
        scaleResolutionDownBy: 2.0,
        scalabilityMode: "S1T3",
      },
      {
        rid: "r2",
        maxBitrate: 900_000,
        scaleResolutionDownBy: 1.0,
        scalabilityMode: "S1T3",
      },
    ],
    // https://mediasoup.org/documentation/v3/mediasoup-client/api/#ProducerCodecOptions
    codecOptions: {
      videoGoogleStartBitrate: 1000,
    },
  },
  aspectRatio: 1.6,
  userMedia: {
    audio: true,
    video: {
      frameRate: { ideal: 15, max: 30 },
      width: {
        min: 320,
        ideal: 1280,
        max: 1920,
      },
      height: {
        min: 200,
        ideal: 800,
        max: 1080,
      },
    },
  },
  displayMedia: {
    chrome: {
      videoBitsPerSecond: 8_000_000,
      video: {
        displaySurface: "monitor",
        width: { ideal: 2560 },
        height: { ideal: 1440 },
        frameRate: { ideal: 30, max: 60 },
      },
      audio: true,
      advanced: [
        { width: 1920, height: 1080 },
        { width: 1280, height: 720 },
      ],
    },
    safari: {
      video: true,
      audio: false,
    },
  },
};

export default config;
